export type LoadingProgressProps = {
  loadingCount: number;
  totalCount: number;
};

export function LoadingProgress({
  loadingCount,
  totalCount,
}: LoadingProgressProps) {
  if (loadingCount === 0) return null;

  const loadedCount = totalCount - loadingCount;
  const progressPercentage = Math.round((loadedCount / totalCount) * 100);

  return (
    <div className="flex items-center gap-3 text-sm text-gray-600">
      <div className="flex items-center gap-2">
        <div className="size-3 animate-spin rounded-full border border-gray-300 border-t-[var(--primary-color)]"></div>
        <span>Fetching data...</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="h-1.5 w-16 overflow-hidden rounded-full bg-gray-200">
          <div
            className="h-full bg-[var(--primary-color)] transition-all duration-300 ease-out"
            style={{ width: `${progressPercentage}%` }}
          ></div>
        </div>
        <span className="text-xs text-gray-500">
          {loadedCount}/{totalCount}
        </span>
      </div>
    </div>
  );
}
